/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import _ from "lodash";
import { VApplication } from "../application";
import { DETAIL_DATA, GRID_OPTIONS, TIMELINE_TABLE_HEADER, ownership ,DATA} from "./test-data/product.detail";
import { EventBusModule } from "@vlinder-web/event-bus-module-react";
import { GET_ASSET_DETAIL } from "../pages/Collectibles/graphql/getasset-detail.query";
import { INITIATE_CLAIM } from "../pages/ProductDetail/graphql/claim-asset.mutation";
import { CHECK_ASSET_LOCK } from "../pages/ProductDetail/graphql/check-asset-lock.query";
import { VERIFY_CLAIMER } from "../pages/ProductDetail/graphql/verify-claimer.query";
import {INITIATE_CLAIM_BY_VOUCHER} from "../pages/ProductDetail/graphql/claim-asset-by-voucher.mutation";
import { LOGIN_MODAL_OPEN, LOGIN_MODAL_CLOSE, LOGIN_SUCCESS } from "../widgets/LoginModalVW";
import { CREATE_TX_CRYPTO } from "../pages/ProductDetail/graphql/create-tx-crypto.mutation";
import moment from 'moment';
import { toast } from "react-hot-toast";
import { SIGN_VOUCHER_MESSAGE } from "./test-data/fiat-purchase-voucher-message";
import { LOCK_ASSET_AFTER_PURCHASE_SUCCESS } from "../pages/ProductDetail/graphql/lock-asset-after-purchase-success.mutation";
import { StorageModule } from "@vlinder-web/storage-module-react";
import {SOUND, VIDEO,PDF_IMAGE} from "../assets/images";
import { humanize } from "uno-js";
import {getErrorMessage} from "../utils/error.message";


const is = require("is_js");

const SERVICE_NAME = "AssetService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};


interface IProps {
    storeId: any,
}



export class AssetDetailService {
    private static instance: AssetDetailService;
    private vapp: VApplication;
    private eventbus: any;
    private storeId: any;
    private imageServer :any;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
        this.eventbus = EventBusModule?.getInstance()?.getEventBus();
        this.storeId = props?.storeId;
        this.imageServer = props?.imageServer;
    }
    public static getInstance(props: any = {}): AssetDetailService {
        if (!AssetDetailService.instance) {
            AssetDetailService.instance = new AssetDetailService(props);
        }
        console.log("AssetDetailService", AssetDetailService.instance)
        return AssetDetailService.instance;
    }

    private _findPrice(price: any[]) {
        let _price =
            is.array(price) &&
            price.map((item) => {
                return {
                    price: `${item?.amount} ${item?.currency}`,
                };
            });

        return _price;
    }

    async getAssetLockState(assetId: string, tokenGroup: string, resell:boolean) {
        log.info(`inside initiate claim service`, assetId);
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("api-gateway");
        try {
            if (client) {
                const res = await client.query({
                    query: CHECK_ASSET_LOCK,
                    variables: {
                        tokenId: assetId,
                        tokenGroupId: tokenGroup,
                        resell:resell
                    },
                    fetchPolicy: 'network-only'
                });
                log.success(SERVICE_NAME, "claim asset result: ", res);
                if (res?.data?.checkLockStatus) {
                    return res?.data?.checkLockStatus;
                }
            }
        } catch (err) {
            getErrorMessage(err);
        }
        // log.blue(SERVICE_NAME, "Asset ID", assetId);
        // return false;
    }

    // private _getImages(data: any, media: any) {
    //     let _img = {
    //         original: data,
    //         thumbnail: data,
    //         thumbnailHeight: "70",
    //         thumbnailClass: "image-thumb",
    //     }

    //     let _data = media?.map((item: any) => {
    //         return {
    //             // ...item,
    //             original: item?.src,
    //             thumbnail: item?.src,
    //             thumbnailHeight: "70",
    //             thumbnailClass: "image-thumb",
    //         };
    //     });
    //     let _images = [_img, ..._data]
    //     return _images;


    // }

    _getImages(data: any,media:any , type:string) {

        const getassetsDetailService = AssetDetailService.getInstance();
        const imgUrl = data?.img;
        const urlFormat = imgUrl?.replace(/^.*\/\/[^\/]+/, '');
        const imgBBformat = imgUrl?.split('/');
        const ibbFormat = imgBBformat[imgBBformat.length-3]
     
        let _imgF;
         if(ibbFormat === "i.ibb.co"){
             _imgF = imgUrl
            // _imgF =`${getassetsDetailService.imageServer}/imgbb${urlFormat}/:/rs=h:500`
         
         } 
         else {
            _imgF = imgUrl
            //  _imgF = `${getassetsDetailService.imageServer}${urlFormat}/:/rs=h:500`
         }
         let _img;

         if(type === "audio"){
             _img = {
                original: data?.thumbnail ?? SOUND,
                thumbnail: data?.thumbnail ?? SOUND,
                thumbnailHeight: "70",
                thumbnailClass: "image-thumb",
                type: "audio",
                 embedUrl: data?.img,
            }
         }
         if(type === "video"){
            _img = {
                original: data?.thumbnail ?? VIDEO,
               thumbnail: data?.thumbnail ?? VIDEO,
               thumbnailHeight: "70",
               thumbnailClass: "image-thumb",
               type: "video",
                embedUrl: data?.img,
           }
        }
         if(type === "image"){
            _img = {
                // original: _imgF,
                // thumbnail: _imgF,
                original: data?.img,
                thumbnail:data?.img,
                thumbnailHeight: "70",
                thumbnailClass: "image-thumb",
            }
         }

         if(type === "doc"){
            _img = {
                // original: _imgF,
                // thumbnail: _imgF,
                original:  data?.thumbnail ?? PDF_IMAGE,
                thumbnail: data?.thumbnail ?? PDF_IMAGE,
                thumbnailHeight: "70",
                thumbnailClass: "image-thumb",
                pdfUrl:data?.img,
                type: "doc",
            }
         }
             
       
        let _data = media?.map((item: any) => {
            console.log("insidde",item)

            const imgUrl = item?.src;
            const urlFormat = imgUrl?.replace(/^.*\/\/[^\/]+/, '');
            const imgBBformat = imgUrl?.split('/');
            const ibbFormat = imgBBformat[imgBBformat.length-3]
         
            let _imgM;
             if(ibbFormat === "i.ibb.co"){
                _imgF =`${getassetsDetailService.imageServer}/imgbb${urlFormat}/:/rs=h:500`
             
             } 
             else {
                 _imgM = `${getassetsDetailService.imageServer}${urlFormat}/:/rs=h:500`
             }

            //    const uriType = ele?.uri.match(/[^:]\w+\/[\w-+\d.]+(?=;|,)/)[0]
             const assetType = item?.type?.substring(0, item?.type?.indexOf('/'))
             console.log(`asset Type`, assetType);
             let selectThumbnail;
             if(assetType === "video"){
                 selectThumbnail = VIDEO
             } else if( assetType === "audio"){
                 selectThumbnail = SOUND
             }else if(assetType ==="doc" ){
                selectThumbnail = PDF_IMAGE
             }
              else {
                //  selectThumbnail = _imgM
                selectThumbnail=item?.src
             }

        
             
          
  
            return {
                // ...item,
                    original: selectThumbnail,
                    thumbnail: selectThumbnail,
                    thumbnailHeight: "70",
                    thumbnailClass: "image-thumb",
                    embedUrl: item?.src ,
                     type: assetType,
            };
        });
        console.log("IMG_DETAIL",[_img,..._data])

        let _images = [_img,..._data]
        return _images;       
    }


    private _getButtons(priceData: any[], claimEnabled: boolean, type:string) {
        let buttons: any = [];
        if (priceData?.length === 0 && claimEnabled) {
            buttons = [
                {
                    key: "claim",
                    title: "Claim"
                }
            ]
        }
        if(type === "doc"){
            buttons.push({
                key:"pdfPreview",
                title:"Preview PDF"
            })
        }
        if (priceData?.length > 0) {
            priceData.map(item => {
                if (item?.type === "crypto") {
                    buttons.push({
                        key: "buyNowCrypto",
                        title: `Buy in ${item?.currency}`
                    })
                }
                if (item?.type === "fiat") {
                    buttons.push({
                        key: "buyNowFiat",
                        title: `Buy in ${item?.currency}`
                    })
                }
            })
        }
        return buttons;
    }

    private _getOwnershipButtons(resData: any) {
        let _tempButtons: any = [];
        if (resData?.viewInIpfs) {
            _tempButtons.push({
                title: "View on Ipfs",
                link: resData?.viewInIpfs
            })
        }
        if (resData?.getAsset?.hasProvenance) {
            _tempButtons.push({
                title: "Proof of Journey",
                link: resData?.getAsset?.provenanceLink
            })
        }
        return _tempButtons;
    }

    _getMeta(data: any[], digitalTwin: string) {
        let _meta = [];

        data?.map((item: any) => {
            _meta.push(
                {
                    key: item?.name,
                    value: item?.val,
                    disp_type: item?.disp_type,
                }
            )
        });

        _meta.push({
            key: "Digital Twin",
            value: digitalTwin,
        });

        return _meta;
    }

    _getAxButtons(resData: any) {
        let _buttons: any = [];
        if (resData) {
            _buttons.push({
                title: "View Proof of Transaction",
                link: resData
            })
        }
        return _buttons;
    }

    async getAssetDetail(assetId: any, tokenGroup?: string) {

        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("api-gateway");
        try {
            if (client) {
                const res = await client.query({
                    query: GET_ASSET_DETAIL,
                    variables: {
                        tokenId: assetId,
                        storeId: this.storeId,
                        tokenGroup: tokenGroup
                    },
                });
                log.info(`date in res`, res?.data)
                if (res) {
                       // let _data = res?.data?.getAsset
                    let _data = assetId === "809" ? DATA?.getAsset : res?.data?.getAsset
                 
                    let _found = {
                        ..._data,
                        idx: _data?.serialNo,
                        title: _data?.title,
                        chainId: _data?.chainId,
                        subtitle: _data?.subtitle,
                        serialNo: `Rare #/ ${_data?.serialNo}`,
                        networkType: _data?.networkType,
                        tag: _data?.tag?.toUpperCase(),
                        category: _data?.tag?.toLowerCase(),
                        price: _data?.price?.map((item: any) => {
                            return ({
                                ...item,
                                locale: 'en-US',
                                amount: item?.amount
                            })
                        }),
                        meta: this._getMeta(_data?.attrs, _data?.digitalTwin),
                        actions: this._getButtons(_data?.price, _data?.claimEnabled,_data?.type),
                        images: this._getImages(_data, _data?.media, _data?.type),
                        ownership: this._getOwnershipButtons(res?.data),
                        info:this._getAxButtons(_data?.tx_proof),
                        nftProvenance: _data?.nftProvenance?.map(item => {
                            console.log("nftprov",item)
                            return ({
                                title: item?.title,
                                profile: {
                                    userName: item?.title === "Owned By" || item?.title ==="Minted By" ? item?.to?.name : item?.from?.name,
                                    fromAddress:item?.title === "Owned By" || item?.title ==="Minted By" ? item?.to?.address : item?.from?.address,
                                    link: item?.form?.link,
                                    tx_proof:item?.tx_proof,
                                    // fromAddress:item?.from?.address,
                                    // toAddress:item?.to?.address,
                                    authProofUrl: res?.data?.viewInIpfs  
                                },
                                eventOccurence: {
                                    date:item?.date
                                },
                                meta: {
                                    ...item?.meta
                                }
                            })
                        }),
                        nftSMProvenance : _data?.nftProvenance?.map((item) => {
                            return {
                                data: [
                                    {
                                        tag: item?.from?.name ?? item?.to?.name,
                                        title: item?.title,
                                        subtitle: item?.from?.name ?? item?.to?.name,
                                        link: item?.form?.link,
                                        price: item?.meta?.priceInFiat ?? item?.meta?.priceInCrypto ,
                                        date: item?.date,
                                        tx_proof:item?.tx_proof,
                                        fromAddress:item?.from?.address,
                                        toAddress:item?.to?.address,
                                        authProofUrl: res?.data?.viewInIpfs 
                                    },
                                ],
                            };
                        }),
                        createdBy: {
                            ..._data?.creator,
                            userId: _data?.creator?.name,
                            userName: _data?.creator?.name,
                            authProofUrl: res?.data?.viewInIpfs
                        },
                        ownedBy: _data?.owner?.name ? {
                            ..._data?.owner,
                            userName: _data?.owner?.name,
                            userId: _data?.owner?.name,
                            authProofUrl: res?.data?.viewInIpfs
                        } : null,
                    }
                    return _found
                };
            }
        }
        catch (err) {
            getErrorMessage(err);
        }
    }

    async openUserLogin() {
        return this.eventbus?.emit(LOGIN_MODAL_OPEN, null, {});
    }

    async initiateClaim(asset: any, signature: any) {
        log.info(`inside initiate claim service`, asset);
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("api-gateway");
        try {
            if (client) {
                const res = await client.mutate({
                    mutation: INITIATE_CLAIM,
                    variables: {
                        input: {
                            tokenId: asset?.idx,
                            tokenGroup: asset?.tokenGroup,
                            storeId: this.storeId
                        },
                        auth: {
                            signature: signature?.result,
                            expected_address: signature?.params[1],
                            message: SIGN_VOUCHER_MESSAGE,
                        }
                    },
                });
                log.success(SERVICE_NAME, "claim asset result: ", res);
                if (res?.data) {
                    return res?.data;
                }
            }
        } catch (err: any) {
            getErrorMessage(err);
        }


    }

    async initiateClaimByVoucher(asset: any, payload: any) {
        log.info(`inside initiate claim service`, asset, payload);
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("api-gateway");
        try {
            if (client) {
                const res = await client.mutate({
                    mutation: INITIATE_CLAIM_BY_VOUCHER,
                    variables: {
                        input: {
                            tokenId: asset?.idx,
                            tokenGroup: asset?.tokenGroup,
                            storeId: this.storeId,
                            voucherCode:payload?.voucherCode,
                        },
                        auth: {
                            signature: payload?.signature?.result,
                            expected_address: payload?.signature?.params[1],
                            message: SIGN_VOUCHER_MESSAGE,
                        }
                    },
                });
                log.success(SERVICE_NAME, "claim asset result: ", res);
                if (res?.data) {
                    return res?.data;
                }
            }
        } catch (err: any) {
            getErrorMessage(err);
        }


    }

    async isUserAuthorized(tokenId: string, tokenGroup: string) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("api-gateway");
        try {
            if (client) {
                const res = await client.query({
                    query: VERIFY_CLAIMER,
                    variables: {
                        tokenId: tokenId,
                        tokenGroup: tokenGroup
                    },
                    fetchPolicy: 'network-only'
                });
                log.success(SERVICE_NAME, "verify claimer: ", res);
                if (res?.data?.verifyClaimer) {
                    return res?.data?.verifyClaimer?.authorized;
                }
                else return false
            }
        } catch (err: any) {
            getErrorMessage(err);
        }
    }
    async isUserLiked(tokenId: string, tokenGroup: string) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("api-gateway");
        try {
            if (client) {
                const res = await client.query({
                    // query: VERIFY_CLAIMER,
                    // variables: {
                    //     tokenId: tokenId,
                    //     tokenGroup: tokenGroup
                    // },
                    // fetchPolicy: 'network-only'
                });
                log.success(SERVICE_NAME, "verify claimer: ", res);
                if (res?.data?.verifyClaimer) {
                    return res?.data?.verifyClaimer?.authorized;
                }
                else return false
            }
        } catch (err: any) {
            getErrorMessage(err);
        }
    }
    

    async createTxCrypto(asset: any, signature: any) {
        log.info(`inside initiate claim service`, asset);
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("api-gateway");
        try {
            if (client) {
                const res = await client.mutate({
                    mutation: CREATE_TX_CRYPTO,
                    variables: {
                        input: {
                            tokenId: asset.idx,
                            tokenGroup: asset.tokenGroup,
                            storeId: this.storeId,
                        },
                        auth: {
                            signature: signature?.result,
                            expected_address: signature?.params[1],
                            message: SIGN_VOUCHER_MESSAGE,
                        }
                    },
                });
                log.success(SERVICE_NAME, "create tx crypto success ", res);
                if (res?.data?.buyAssetInCrypto) {
                    return res?.data?.buyAssetInCrypto;
                }
            }
        } catch (err: any) {
            getErrorMessage(err);
        }
    }

    async sendTxResult(asset: any, txResult: any) {
        log.info(`inside tx result`, txResult);
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("api-gateway");
        try {
            if (client) {
                const res = await client.mutate({
                    mutation: LOCK_ASSET_AFTER_PURCHASE_SUCCESS,
                    variables: {
                        input: {
                            tokenId: asset?.idx,
                            tokenGroup: asset.tokenGroup,
                            txnType: 'crypto',
                            hash: txResult?.txResult?.txHash,
                            tx_id:txResult?.tx_id
                        },
                        auth: {
                            signature: txResult?.signature?.result,
                            expected_address: txResult?.signature?.params[1],
                            message: SIGN_VOUCHER_MESSAGE,
                        }
                    },
                });
                if (res?.data) {
                    return res?.data;
                }
            }
        } catch (err: any) {
            getErrorMessage(err);
        }
    }
}


